import React from "react";
import "../styles/pages.css";

function WebCraft() {
  const handleProjectClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <div className="webcraft-page">
      <div className="webcraft-hero">
        <div className="webcraft-hero-content">
          <h1 className="webcraft-title fade-in">Our Projects</h1>
          <p className="webcraft-subtitle slide-up">
            Explore our portfolio of custom digital solutions designed to meet
            specific client requirements and deliver exceptional user
            experiences.
          </p>
        </div>
      </div>

      <div className="portfolio-section">
        <div className="container">
          <div className="portfolio-grid">
            <div
              className="portfolio-card fade-in premium-card clickable-project"
              onClick={() => handleProjectClick("https://latelierno1.au/")}
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/latelierno1.jpg"
                  alt="L'Atelier No.1"
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>L'Atelier No.1</h3>
                <p>
                  Sydney based hair salon with a focus on providing premium hair
                  services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card fade-in premium-card clickable-project"
              style={{ animationDelay: "0.2s" }}
              onClick={() => handleProjectClick("https://orano1.au")}
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/ora.png"
                  alt="Ora No.1"
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>Ora No.1</h3>
                <p>
                  Lidcombe based beauty salon with a focus on providing premium
                  beauty services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card fade-in premium-card clickable-project"
              style={{ animationDelay: "0.3s" }}
              onClick={() => handleProjectClick("https://hanjinremoval.au")}
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/hanjinRemoval.png"
                  alt="Hanjin Removal"
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>Hanjin Removal</h3>
                <p>
                  Auburn based removal company with a focus on providing premium
                  removal services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card fade-in premium-card clickable-project"
              style={{ animationDelay: "0.4s" }}
              onClick={() =>
                handleProjectClick(
                  "https://permpermhair.simplybook.net/v2/?google-maps-booking-channel=1#"
                )
              }
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/permperm.png"
                  alt="Perm Perm Hair"
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>Perm Perm Hair</h3>
                <p>
                  Lidcombe based hair salon with a focus on providing premium
                  hair services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card fade-in premium-card clickable-project"
              style={{ animationDelay: "0.5s" }}
              onClick={() =>
                handleProjectClick(
                  "https://play.google.com/store/apps/details?id=com.snm9606.MentalHealth5"
                )
              }
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/MentalHealthSolution.jpg"
                  alt="Mental Health Solution"
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary">View on Google Play</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>Mental Health Solution</h3>
                <p>
                  A comprehensive mental health app that provides resources,
                  tracking tools, and support features for users managing their
                  mental wellbeing.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card fade-in premium-card clickable-project"
              style={{ animationDelay: "0.6s" }}
              onClick={() =>
                handleProjectClick("https://hello-jennyshair.com.au/")
              }
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/flare.jpg"
                  alt="Jennys House the beginning"
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>Jennys House the beginning</h3>
                <p>
                  A sophisticated website for a premium hair and beauty salon in
                  EastWood and Castle Hill.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card fade-in premium-card clickable-project"
              style={{ animationDelay: "0.7s" }}
              onClick={() => handleProjectClick("https://mykoreanteacher.au/")}
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/mykoreanteacher.jpg"
                  alt="My Korean Teacher"
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>My Korean Teacher</h3>
                <p>
                  Lidcombe based Korean language education services with a focus
                  on providing premium Korean language education services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>

            <div
              className="portfolio-card fade-in premium-card clickable-project"
              style={{ animationDelay: "0.8s" }}
              onClick={() => handleProjectClick("https://withu.au/")}
            >
              <div className="portfolio-img-container">
                <img
                  src="/images/withu.jpg"
                  alt="With U Beauty"
                  className="portfolio-img"
                />
                <div className="portfolio-overlay">
                  <span className="btn btn-primary">Visit Website</span>
                </div>
              </div>
              <div className="portfolio-info">
                <h3>With U Beauty</h3>
                <p>
                  Strathfield based beauty salon with a focus on providing
                  premium beauty services.
                </p>
                <div className="view-project">
                  View <span>→</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="webcraft-cta">
        <div className="container">
          <div className="cta-content text-center">
            <h2 className="fade-in">Create an Innovative Digital Solution</h2>
            <p className="slide-up">
              Looking to develop a custom application or website for your
              business? PICKTECH's expert team is here to bring your vision to
              life.
            </p>
            <a
              href="/contact"
              className="btn btn-primary slide-up"
              style={{ animationDelay: "0.3s" }}
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WebCraft;
